#import "../fragments/role-fragment.graphql"

mutation DeleteRole($input: RoleDeleteInput!) {
    roleDelete(input: $input) {
        role {
            ...RoleFragment
        }
    }
}
